import {
  EnvironmentProviders,
  ErrorHandler,
  Provider,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { UnleashClient } from 'unleash-proxy-client';

export interface SentryConfig {
  enabled?: boolean;
  environment?: string;
  release?: string;
  tracesSampleRate?: number;
  replaysSessionSampleRate?: number;
  replaysOnErrorSampleRate?: number;
  unleash?: boolean;
  captureHttpErrors?: boolean;
}

export const initializeSentry = (dsn: string, config?: SentryConfig) => {
  Sentry.init({
    dsn,
    enabled: config?.enabled === true,
    environment: config?.environment,
    release: config?.release,
    integrations: [
      ...(config?.captureHttpErrors !== false
        ? [Sentry.httpClientIntegration()]
        : []),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      ...(config?.unleash === true
        ? [Sentry.unleashIntegration({ featureFlagClientClass: UnleashClient })]
        : []),
    ],
    tracesSampleRate: config?.tracesSampleRate ?? 0.05,
    replaysSessionSampleRate: config?.replaysSessionSampleRate ?? 0.05,
    replaysOnErrorSampleRate: config?.replaysOnErrorSampleRate ?? 0.1,
    sendDefaultPii: true,
  });
};

export const provideSentry: Array<Provider | EnvironmentProviders> = [
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false,
    }),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  provideAppInitializer(() => {
    inject(Sentry.TraceService);
  }),
];

export const sentrySetUser = (userId: string | undefined) => {
  Sentry.setUser(
    userId
      ? {
          id: userId,
          username: userId,
        }
      : null,
  );
};
